import styled, { keyframes, css, DefaultTheme } from 'styled-components';

import { media } from '~src/styles/media-templates';
import { fadeIn } from '~src/styles/animations/animations.sc';

const slideFromRight = keyframes`
  from {
    margin-right: -600px;
  }
  to {
    margin-right: 0;
  }
`;

export const slideFromBottom = keyframes`
  from {
    transform: translateY(200%);
  }
  to {
    transform: translateY(0);
  }
`;

export const RedirectNavigation = styled.div<{
  $redirect: boolean;
  $timeForSlidingOut: number;
  $timeForSlidingIn: number;
}>(
  ({ theme, $redirect, $timeForSlidingOut, $timeForSlidingIn }) => css`
    background-color: ${$redirect ? theme.baseBlue.a10 : theme.black.a3};
    width: ${$redirect ? '100%' : '647px'};
    transition: all ease ${$timeForSlidingOut}ms;
    height: 100%;
    animation: ${slideFromRight} ${$timeForSlidingIn}ms ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.73;
    color: ${theme.white.a10};
    padding: 3rem;
    ${media.phone`
      width: 100%;
      height: fit-content;
      background-color: rgba(50, 54, 69, 0.4);
      position: absolute;
      top: ${$redirect ? '-100%' : '40%'};
      transition: all 1s ease;
      animation: ${slideFromBottom} ${$timeForSlidingIn}ms linear;
    `}
  `,
);

export const RedirectContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.baseBlue.a10};
  display: flex;
  ${media.phone`
    height: auto;
    display: block;
    min-height: 100%;
  `}
`;

export const HeaderContainer = styled.div`
  color: white;
  ${media.phone`
    font-size: 12px;
  `}
`;

export const Separator = styled.span`
  padding: 0 0.5rem;
`;

export const CycleTitle = styled.span`
  font-size: 21px;
  line-height: 1;
  font-weight: 200;
  margin-left: 5px;
  width: 250px;
  ${media.phone`
    font-size: 15px;
  `}
`;

export const LoopPicture = styled.div<{ $moreQuestions?: boolean }>`
  width: ${({ $moreQuestions }) => ($moreQuestions ? 556 : 360)};
  height: ${({ $moreQuestions }) => ($moreQuestions ? 417 : 271)};
  ${media.phone`
    display: ${({ moreQuestions }) => (moreQuestions ? 'none' : 'block')};
    height: 187px;
    width: 249px;
  `}
  svg {
    width: 100%;
    height: 100%;
    display: block;
    pointer-events: none; /* ie11 */
  }
`;

export const CycleName = styled.span`
  line-height: 1.67;
  ${media.phone`
    line-height: 26px;
  `}
`;

export const InfoContainer = styled.div`
  margin-top: 30px;
  color: ${({ theme }) => theme.white.a10};
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: start;
  ${media.phone`
    margin-top: 15px;
  `}
`;

export const SuccessTitle = styled.div`
  color: ${({ theme }) => theme.white.a10};
  font-size: 27px;
  text-align: center;
  line-height: 1.67;
  margin-top: 2.666rem;
  max-width: 24rem;
  padding: 0 1.6rem;
  ${media.phone`
    display: block;
    margin-top: 10px;
    font-size: 21px;
  `}
`;

export const SuccessSubTitle = styled.div<{ $moreQuestions?: boolean }>`
  color: ${({ theme }) => theme.white.a10};
  font-size: 1rem;
  text-align: center;
  line-height: 1.67;
  max-width: 24rem;
  margin-top: 0.666rem;
  margin-bottom: 15px;
  ${media.phone`
    display: ${({ $moreQuestions }) => ($moreQuestions ? 'none' : 'block')};
  `}
`;

export const LogOutContainer = styled.div<{ $moreQuestions: boolean }>`
  display: ${({ $moreQuestions }) => ($moreQuestions ? 'none' : 'block')};
`;

export const ButtonContainer = styled.div<{ $hide: boolean }>`
  opacity: ${({ $hide }) => ($hide ? '0' : '1')};
  transition: all ease 1s;
  width: 326px;
`;

export const SuccessMessage = styled.span<{ $showRedirect?: boolean }>`
  animation: ${fadeIn} 0.3s;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${media.phone`
    filter: ${({ $showRedirect }) => ($showRedirect ? 'blur(20px)' : 'none')};
    transition: all 1s ease;
  `}
`;

export const RedirectContentWrapper = styled.div<{ $moreQuestions: boolean/*; redirect: boolean */}>`
  height: 100%;
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.white.a10};
  font-size: 40px;
  /* margin-left: {({ redirect }) => (redirect ? '-100%' : '0')};*/
  transition: margin-left ease 1s;
  background-color: ${({ theme }) => theme.baseBlue.a10};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6rem 3.333333rem 8rem 3.333333rem;

  @media only screen and (min-height: 833px) {
    display: ${({ $moreQuestions }) => ($moreQuestions ? 'flex' : 'block')};
  }

  ${media.phone`
    background-color: ${({ theme }) => (theme as DefaultTheme).mobileBlue.a10};
    margin-left: 0;
    padding: 30px 10px;
  `}
`;
